import {Options, Vue} from 'vue-class-component';

@Options({
  components: {
  },
})
export default class HelpScreen extends Vue {

  mounted() {
    document.body.classList.add('modal-open');
  }

  beforeUnmount() {
    document.body.classList.remove('modal-open');
  }

}
